import React from "react";
import styled from "@emotion/styled";
import { ChecklistItem } from "@ecologi/shared";
import { Section, BackgroundVariant } from "../Section";
import { AddNewItem, AddNewItemProps } from "./components/AddNewItem";
import { AddNewItemBusiness } from "./components/AddNewItemBusiness";
import {
  ProfileChecklistItem,
  ProfileChecklistItemHandlers,
} from "./components/ProfileChecklistItem";
import { groupBy } from "./utils/group-by";

const List = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
`;

type Props = {
  isOwnProfile: boolean;
} & ProfileChecklistItemHandlers &
  AddNewItemProps;

export const ProfileChecklist = ({
  user,
  isOwnProfile,
  onRemoveChecklistItem,
  onToggleChecklistItem,
  onAddChecklistItem,
}: Props) => {
  const allChecklistItems = user.checklistItems || [];
  // Get the checklist items from the user
  const checklistItems = groupBy(allChecklistItems, "isComplete");

  // Make sure it's an array as it can come back `undefined`
  const tasksComplete = checklistItems.true || [];
  const tasksIncomplete = checklistItems.false || [];

  const name = isOwnProfile
    ? user.isFamilyPlan
      ? "Your family’s"
      : "Your"
    : user.isFamilyPlan
    ? user.fullNamePlural
    : user.firstNamePlural;
  const title =
    user.isBusinessPlan || user.isSubscriptionless
      ? `${user.fullNamePlural} sustainability goals`
      : `${name} climate lifestyle choices`;

  return (
    <Section backgroundVariant={BackgroundVariant.MUSHROOM} id="tour-checklist">
      <Section.Heading
        title={title}
        subtitle={
          user.isBusinessPlan
            ? (isOwnProfile ? "Your" : "Their") +
              ` journey to
          becoming a low carbon business`
            : `The biggest impact you can have, is
          change your lifestyle`
        }
        marginBottomOverride="10px"
      />

      {isOwnProfile && user.isBusinessType && (
        <AddNewItemBusiness
          user={user}
          onAddChecklistItem={onAddChecklistItem}
        />
      )}
      {isOwnProfile && !user.isBusinessType && (
        <AddNewItem user={user} onAddChecklistItem={onAddChecklistItem} />
      )}

      {allChecklistItems.length > 0 && (
        <List>
          {[...tasksIncomplete, ...tasksComplete].map((item: ChecklistItem) => (
            <ProfileChecklistItem
              onRemoveChecklistItem={onRemoveChecklistItem}
              onToggleChecklistItem={onToggleChecklistItem}
              isOwnProfile={isOwnProfile}
              item={item}
              key={item._id}
              user={user}
            />
          ))}
        </List>
      )}
    </Section>
  );
};
